class AjaxForm extends HTMLElement{
    constructor(){
        super();
        this.form = this.querySelector('form');
        this.submit = this.querySelector('[type="submit"]');
    }

    connectedCallback(){
        this.submit.addEventListener("click", (e)=> this.onSubmit(e));
    }

    //takes form as argument to use it in onload function 
    onSubmit(e){
        e.preventDefault(); // Prevent default form submission

        // Capture form data
        const formData = new FormData(this.form);

        // Send AJAX request
        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.form.action); // Set the request method and URL from the form
        
        xhr.onload = function() {
            if (xhr.status === 200) {
                console.log('Form submitted successfully!');
            } else {
                console.error('Error submitting form:', xhr.statusText);
            }
        };

        xhr.send(formData);
    }

}

customElements.define("ajax-form", AjaxForm);


class NewsletterForm extends AjaxForm{
    constructor(){
        super();
        this.email = this.querySelector('[type="email"]');
        this.errorMessage = this.querySelector(".form__message.custom_error");
        this.content = this.querySelector(".content_wrapper");
        this.promo = this.querySelector(".custom_success");
        this.emailError = this.errorMessage.dataset.errorMessage;
    }

    connectedCallback(){
        this.submit.addEventListener("click", (e)=> this.onSubmit(e));
        if (this.formSubmitted()) {
            this.markTealiumPending();
            this.hideForm();
        }
    }

    formSubmitted(){
        const params = new URLSearchParams(window.location.search);
        
        if (params.get("customer_posted") == "true"){
            this.email.removeAttribute('aria-invalid');
            return true;
        }
        return false;
    }

    hideForm(){
        this.content.style.display = "none";
    }

    showPromo(){
        this.promo.style.display = "flex";
    }

    markTealiumPending() {
        try {
            sessionStorage.setItem('tealium_newsletter_sub_pending', '1');
            sessionStorage.removeItem('tealium_newsletter_sub_consumed');
        } catch (error) {
            console.warn('Unable to set newsletter subscription flag', error);
        }
    }

    hideMailError(){
        this.errorMessage.style.display = "none";
    }

    showMailError() {
        this.errorMessage.style.display = "flex";
        this.email.setAttribute('aria-invalid', 'true');
        this.email.setAttribute('aria-label', 'the email is invalid');

    
        // Trova l'elemento dell'errore e lo svuota
        const errorElement = this.errorMessage.querySelector('#newsletter-error');
        
        // Rimuovi il contenuto attuale
        errorElement.innerHTML = '';  
        
        // Aggiorna il contenuto dell'errore con un leggero ritardo per garantire che aria-live lo legga
        setTimeout(() => {
            errorElement.innerHTML = this.emailError;

        }, 100);
        
        // Metti a fuoco l'elemento input in errore per migliorare l'accessibilità
        this.email.focus();
    }
    
    onSubmit(e){
        e.preventDefault(); // Prevent default form submission

        if(!this.email.checkValidity()){
            this.showMailError();
            return;
        }
        // Capture form data
        const formData = new FormData(this.form);

        // Send AJAX request
        const xhr = new XMLHttpRequest();
        xhr.open('POST', this.form.action); // Set the request method and URL from the form

        xhr.addEventListener("load", ()=>{
            //if recaptcha is active
            if(xhr.responseURL.includes("challenge")){
                this.markTealiumPending();
                this.form.submit();
                return;
            }
            if (xhr.status === 200) {
                console.log('Form submitted successfully!');
                this.markTealiumPending();
                this.hideForm();
                this.showPromo();
                if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                    publish(PUB_SUB_EVENTS.newsletterSubscribed, {});
                }
            } else {
                console.error('Error submitting form:', xhr.statusText);
            }
        });

        xhr.send(formData);
    }

}

customElements.define("newsletter-form", NewsletterForm);
